module.exports = __webpack_public_path__ + "media/images/shared/bg-student-45d9c80b09a18109fb297309a56dfa60.svg";